import { NodeType } from '../types';

import type { Branch, Fragment, Node } from '../types';

export function isBranchNode<T extends Node | Fragment>(
  node: T
): node is Branch<T> {
  return node.type === NodeType.branch;
}
